if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.mq = window.matchMedia('(max-width: 749px)');
        this.onScroll = this.onScroll.bind(this);
      }

      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.mainPrice = document.getElementById(`price-${this.sectionId}`);
        this.price = this.querySelector('[data-sticky-price]');
        this.button = this.querySelector('[data-sticky-submit]');
        this.label = this.querySelector('[data-sticky-label]');
        if (!this.mainButton) return;

        this.button.addEventListener('click', () => {
          if (this.mainButton.disabled) return;
          this.mainButton.click();
        });

        this.observer = new IntersectionObserver((entries) => {
          this.buttonVisible = entries[0].isIntersecting;
          this.buttonAbove = entries[0].boundingClientRect.top < 0;
          this.update();
        });
        this.observer.observe(this.mainButton);

        this.mutation = new MutationObserver(() => this.sync());
        this.mutation.observe(this.mainButton, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
        if (this.mainPrice) this.mutation.observe(this.mainPrice, { childList: true, subtree: true });

        this.mq.addEventListener('change', () => this.update());
        document.addEventListener('scroll', this.onScroll, { passive: true });
        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.mutation?.disconnect();
        document.removeEventListener('scroll', this.onScroll);
        document.body.classList.remove('am-sticky-atc-visible');
      }

      onScroll() {
        const nearBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 120;
        if (nearBottom !== this.nearBottom) {
          this.nearBottom = nearBottom;
          this.update();
        }
      }

      sync() {
        if (this.mainPrice && this.price) {
          this.price.innerHTML = this.mainPrice.innerHTML;
          this.price.querySelectorAll('.badge').forEach((badge) => badge.remove());
          this.price.classList.toggle('hidden', this.mainPrice.classList.contains('hidden'));
        }
        const text = this.mainButton.querySelector('span')?.textContent?.trim();
        if (text && this.label) this.label.textContent = text;
        this.button.disabled = this.mainButton.disabled;
      }

      update() {
        const popupOpen = document.body.classList.contains('am-popup-open');
        const show = this.mq.matches && this.buttonAbove && !this.buttonVisible && !this.nearBottom && !popupOpen;
        this.hidden = !show;
        this.setAttribute('aria-hidden', String(!show));
        document.body.classList.toggle('am-sticky-atc-visible', show);
      }
    }
  );
}
